import React, { useContext } from 'react';

import { CurrencyContext, MobileContext } from 'context/index.js';
import { NetworkCurrencySymbol, FiatCurrencySymbol } from 'components/CurrencySymbols';
import { useGameDetails } from 'utils/Hooks';
import { REWARD_PRECISION_DECIMALS } from 'const';
import 'styles/animations.scss';

export function RoundNotLoadedYet(roundData) {
  if (roundData === undefined) throw new SyntaxError('missing required argument: roundData');
  return (!roundData?.epoch);
}

function CardBaseFC(props) {
  const isMobile = useContext(MobileContext);
  const { currencyID } = useContext(CurrencyContext);

  const gameDetails = useGameDetails();
  const rewardDecimalsToShow = REWARD_PRECISION_DECIMALS[gameDetails.wantedChain.name];


  function RoundNotLoadedYet() {
    return (!props.round);
  }

  function ExecutionNotice() {
    if (props.roundExpired)
      return (<div id="ExecutionNotice">
        <p style={{ fontSize: "2.8em" }} className="glowing">
          Executing
        </p>
        <div className="w-full container">
          <div className="box mx-auto">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
          </div>
        </div>
      </div>);
    else return null;
  }


  function PrizePool() {
    let output;
    if (RoundNotLoadedYet()) {
      output = null;
    } else {
      const round = props.round;
      const totalPrizePool = ((Number(round.bullAmount) + Number(round.bearAmount)) / 10 ** 18).
        toFixed(rewardDecimalsToShow);
      output = (<div className='PrizePoolContainer'>
        <div className='Separator' />
        {/*
        
      Stuck debugging this. Adding ThemeBox here does something funky with the padding 
      
    */}
        <div className={'ThemeBox PrizePool' + (props.flashIfTooLow ? 'Flashing' : '')}>
          Prize pool:
          <span style={{ display: "flex", alignItems: "center" }}>
            {currencyID == 0 ? <>
              <div className='Figure'>{totalPrizePool}</div>
              <NetworkCurrencySymbol />
              <FiatCurrencySymbol cryptoAmount={totalPrizePool} />
            </> : <>
              <FiatCurrencySymbol cryptoAmount={totalPrizePool} />
              <NetworkCurrencySymbol />
            </>}
          </span>
        </div>
      </div>);
    }
    return output;
  }

  if (props.noPremadeLayout)
    return (
      <div className={'ThemeCardBase Card ' + props.cardName + ' ' + (props.additionalCssStyles || '') +
        (isMobile ? ' Mobile' : ' Desktop')}
        style={props.style || {}}
      >
        {[props.children]}
      </div>
    );
  else
    return (
      <div className={'ThemeCardBase Card ' + props.cardName + ' ' + (props.additionalCssStyles || '') +
        (isMobile ? ' Mobile' : ' Desktop')}
        style={props.style || {}}
      >
        <div className='Header'>
          {props.cardName} Round #{RoundNotLoadedYet() ? '-' : props.round.epoch}
          <div className='Separator' />
        </div>
        {[props.children]}
        {PrizePool()}
      </div>
    );
}

export default CardBaseFC;

/*

props.flashIfTooLow
props.roundExpired
props.round

*/
